import { forwardRef, useEffect, ForwardRefExoticComponent, RefAttributes, useContext } from 'react';
import { Link, useLocation } from 'react-router';

// material-ui
import { Box, ListItemButton, ListItemIcon, ListItemText, Typography } from '@mui/material';

// types
import { LinkTarget, NavItemType } from 'types/menu';
import { MenuContext } from 'contexts';
import { securelyRetrieveData } from 'utils';

// ==============================|| NAVIGATION - LIST ITEM ||============================== //

interface Props {
  item: NavItemType;
  level: number;
}

const NavItem = ({ item, level }: Props) => {

  const { menuState, setMenuState } = useContext(MenuContext);

  const retrievedDrawerOpen = securelyRetrieveData("drawerOpen");
  const drawerOpen = retrievedDrawerOpen !== undefined ? retrievedDrawerOpen : true;
  const openItem = menuState.openItem;

  let itemTarget: LinkTarget = '_self';
  if (item.target) {
    itemTarget = '_blank';
  }

  let listItemProps: {
    component: ForwardRefExoticComponent<RefAttributes<HTMLAnchorElement>> | string;
    href?: string;
    target?: LinkTarget;
  } = { component: forwardRef((props, ref) => <Link {...props} to={item.url!} target={itemTarget} />) };
  if (item?.external) {
    listItemProps = { component: 'a', href: item.url, target: itemTarget };
  }

  const isSelected = openItem.findIndex((id) => id === item.id) > -1;

  const { pathname } = useLocation();

  // active menu item on page load
  useEffect(() => {
    if (pathname.startsWith('/profile/')){
      setMenuState(menuState => ({
        ...menuState,
        openItem: []
      }));
    }
    if (item.processUrl && pathname.startsWith(item.processUrl)) {
      setMenuState(menuState => ({
        ...menuState,
        openItem: [item.id!]
      }));
    }
  }, [pathname]);

  return (
    <>
      <Box sx={{ paddingX: drawerOpen ? "10px" : "8px", paddingY: "2px", display: "flex", alignItems: "center", justifyContent: "center" }}>
        <ListItemButton
          {...listItemProps}
          disabled={item.disabled}
          selected={isSelected}
          sx={{
            height: "46px",
            zIndex: 1201,
            display: "flex",
            ml: (drawerOpen) ? `${(level - 1) * 12}px` : undefined,
            justifyContent: "center",
            alignItems: "center",
            borderRadius: "4px",
            '&:hover': {
              bgcolor: "#1C83E2"
            },
            '&.Mui-selected': {
              bgcolor: "#1C83E2",
              '&:hover': {
                bgcolor: "#1C83E2"
              },
            }
          }}
        >
          {(drawerOpen || (!drawerOpen && level === 1)) &&
            <ListItemIcon
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              {item.icon && level === 1 && (
                <item.icon color={isSelected ? "white" : "#BFBABA"} />
              )}
            </ListItemIcon>
          }
          {((drawerOpen) || (level !== 1 && !drawerOpen)) && (
            <ListItemText
              primary={
                <Typography variant="h6" sx={{ marginLeft: "10px", color: isSelected ? "white" : ((!drawerOpen && level !== 1) ? "black" : "#BFBABA") }}>
                  {item.title}
                </Typography>
              }
            />
          )}
        </ListItemButton>
      </Box>
    </>
  );
};

export default NavItem;
